import { fetchJson } from './client';

export const share = {
  getProject: (token: string) => fetchJson<any>(`/share/${token}`),
};
